import { blogApi } from "../../api";
import { getSanityClient } from "../../../utils/sanityClient";
import {
  BLOG_CATEGORIES_QUERY,
  BLOG_POSTS_LIST_QUERY,
  BLOG_POST_BY_SLUG_QUERY,
} from "./blog.queries";
import { BlogCategory, BlogPost, BlogPostSummary } from "./blog.types";

export const blogFeatureApi = blogApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getBlogPosts: builder.query<BlogPostSummary[], void>({
      queryFn: async () => {
        try {
          const data = await getSanityClient().fetch<BlogPostSummary[]>(
            BLOG_POSTS_LIST_QUERY,
          );
          return { data };
        } catch (error) {
          return { error: { status: "CUSTOM_ERROR", error: String(error) } };
        }
      },
    }),
    getBlogPostBySlug: builder.query<BlogPost | null, string>({
      queryFn: async (slug) => {
        try {
          const data = await getSanityClient().fetch<BlogPost | null>(
            BLOG_POST_BY_SLUG_QUERY,
            { slug },
          );
          return { data };
        } catch (error) {
          return { error: { status: "CUSTOM_ERROR", error: String(error) } };
        }
      },
    }),
    getBlogCategories: builder.query<BlogCategory[], void>({
      queryFn: async () => {
        try {
          const data = await getSanityClient().fetch<BlogCategory[]>(
            BLOG_CATEGORIES_QUERY,
          );
          return { data };
        } catch (error) {
          return { error: { status: "CUSTOM_ERROR", error: String(error) } };
        }
      },
    }),
  }),
});

export const {
  useGetBlogPostsQuery,
  useGetBlogPostBySlugQuery,
  useGetBlogCategoriesQuery,
} = blogFeatureApi;
